module.exports = __webpack_public_path__ + "media/images/emblems/Frauenfeld-coat_of_arms-f388498f5e0a96655b4e7ec79485d2b1.png";